import { PaidFeature } from '@baserow_premium/paidFeatures'
import { AuditLogPaidFeature } from '@baserow_enterprise/paidFeatures'

export class AdvancedAuditLogPaidFeature extends AuditLogPaidFeature {
  getImage() {
    return '/img/features/workspace_audit_log.png'
  }
}

export class ApplicationBuilderSSOPaidFeature extends PaidFeature {
  static getType() {
    return 'ab_sso'
  }

  getPlan() {
    return 'Advanced'
  }

  getIconClass() {
    return 'iconoir-log-in'
  }

  getName() {
    return this.app.$i18n.t('advancedFeatures.abSSO')
  }

  getImage() {
    return '/img/features/ab_sso.png'
  }

  getContent() {
    return this.app.$i18n.t('advancedFeatures.abSSOContent')
  }
}
